export default __webpack_public_path__ + "static/media/tablet_confirmation.b4ab9cde.svg";